import { useIsMobile } from './use-is-mobile';

export function useIsDesktop() {
  const isMobile = useIsMobile();
  return !isMobile;
}
